/** @format */

import React from "react";
import Card from "./landing/Card";
import CardSection from "./landing/CardSection";
import CardIcon1 from "../assets/CardIcon1.svg";
import CardIcon2 from "../assets/CardIcon2.svg";
import CardIcon3 from "../assets/CardIcon3.svg";
import Title from "./landing/Title";
import Subtitle from "./landing/Subtitle";

const CardItem = [
  {
    title: "DETAILED PERSONAL DATA",
    summary:
      "Create routines and reminders that are tailored to you, your goals, and your schedule.",
    icon: CardIcon1,
  },

  {
    title: "EXERCISE COMPANION",
    summary:
      "You no longer have to worry about lacking the motivation to exercise because our app will be with you every step of the way.",
    icon: CardIcon2,
  },

  {
    title: "DAILY PROGRESS REPORT",
    summary:
      "Get a detailed summary of your activity and how much closer you are to your fitness goals.",
    icon: CardIcon3,
  },
];

const WhyChooseUs = () => {
  return (
    <div className="why-choose-us-bg pt-[64px] pb-[80px]">
      <div className="flex flex-col justify-center items-center mb-[120px]">
        <Title title="WHY CHOOSE US" titleClass="title-text" />
        <Subtitle summary="Our 30+ team members are working day and night to bring effective workouts to your home through the FitStats app." />
      </div>
      <CardSection>
        {CardItem &&
          CardItem.map((card, key) => (
            <Card
              flex={false}
              key={key}
              title={card.title}
              summary={card.summary}
              icon={card.icon}
            />
          ))}
      </CardSection>
    </div>
  );
};

export default WhyChooseUs;
